/**
 * Created by Jie Gao on 2021-02-24.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GGParsedInitData} from "../server/data/GGParsedInitData";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GGGameConfig} from "../GGGameConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FontStyleConfig} from "../config/FontStyleConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite} from "gsap";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class FSCounter extends BaseView {
    private _badgeName:string;
    private _posPortrait:[number, number] = [77, -95];
    private _posLandscape:[number, number] = [-89, 74];
    private _isFSRestore:boolean = false;

    private _badge:PIXI.Sprite;
    private _badgeFSType:PIXI.Sprite;

    private _hasParsedInitData:boolean = false;
    private _isShowing:boolean = false;
    private _isPortrait:boolean = false;
    private _fsLeft:number;
    private _bombSpinsLeft:number;
    private _spinsLeft:number;
    private _numberOnBoard:number = 0;
    private _flagNumber:PIXI.BitmapText;
    private _effect:PIXI.spine.Spine;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._badge = new PIXI.Sprite();
        this._badge.name = "fsBadge";
        this._badge.anchor.set(0.5, 0.5);

        this._effect = new PIXI.spine.Spine(GameResources.getSpineAsset("SFS"));
        this._effect.visible = false;
        this._effect.renderable = false;
        this._badge.addChild(this._effect);

        this._flagNumber = new PIXI.BitmapText("", FontStyleConfig.SpinsMultiplier);
        this._flagNumber.letterSpacing = -40;
        this._badge.addChild(this._flagNumber);

        this._badgeFSType = new PIXI.Sprite();
        this._badgeFSType.anchor.set(0.5, 0.5);
        this._badge.addChild(this._badgeFSType);

        //this.showFlag("fsBadge_normal_bomb", 10);
        //StageManager.getLayer(GGGameConfig.instance.LAYERS.REEL_FOREGROUND.name).addChild(this._badge);
    }

    protected onResize(resizeData:IResizeData):void {
        const isPortrait:boolean = resizeData.orientation === Orientation.PORTRAIT;
        this._isPortrait = isPortrait;
        if(!this._isShowing || !this._badge) {
            return;
        }
        this.resetPositions();
    }

    private resetPositions():void {
        const isPortrait:boolean = this._isPortrait;
        const pos:number[] = isPortrait ? this._posPortrait : this._posLandscape;
        this._effect.state.setAnimation(0, isPortrait ? "P_Still" : "L_Still", true);
        this._effect.renderable = true;
        this._effect.visible = true;
        //const badgeTextureName =`featureSign_${isPortrait ?"portrait":"landscape"}`;
        //this._badge.texture = GameResources.getTextures(badgeTextureName)[0];
        this._badge.position.set(pos[0], pos[1]);
        this.updateNumberPos();
        this._badgeFSType.position.set(isPortrait ? 2 : -118, isPortrait ? -96 : 10);
        this._effect.position.set(0, 0);
    }

    public updateToSpinsLeft(spinsLeft:number, bordName:string = "", withRetrigger:boolean = true):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(spinsLeft === this._numberOnBoard) {
            return tl;
        }
        const increase:boolean = spinsLeft > this._numberOnBoard;
        let startTime:number = 0;
        if(bordName.length > 0) {
            tl.add(() => this._badgeFSType.texture = GameResources.getTextures(bordName)[0]);
        } else if(withRetrigger){
            tl.add(() => GGGameModuleConfig.soundPlayer.playRetriggerSound(), startTime);
        }
        for(let i:number = 0; i < (Math.abs(spinsLeft - this._numberOnBoard)); i++) {
            tl.add(() => {
                const newNumber:number = this._numberOnBoard + (increase ? 1 : -1);
                this.updateSpinsLeft(newNumber);
                SlotGame.keypad.setZeroBetSpinCounter(newNumber);
            }, startTime);
            startTime += 0.4;
        }
        tl.add(() => {}, startTime);
        return tl;
    }

    public updateSpinsLeft(spinsLeft:number, withAnimation:boolean = true):void {
        const isPortrait:boolean = this._isPortrait;
        if(this._effect && withAnimation) {
            this._effect.renderable = true;
            if(spinsLeft != this._numberOnBoard) {
                this._effect.state.setAnimation(0, `${isPortrait ? "P" : "L"}_${spinsLeft > this._numberOnBoard ? "Increase" : "Decrease"}`, false);
                GGGameModuleConfig.soundPlayer.playFSCounterUpdateSound(spinsLeft > this._numberOnBoard);
            }
        }
        this._flagNumber.text = spinsLeft.toString();
        this._numberOnBoard = spinsLeft;
        this.updateNumberPos();
    }

    private updateNumberPos():void {
        const isPortrait:boolean = this._isPortrait;
        this._flagNumber.position.set((isPortrait ? -13 : -13) - ((this._numberOnBoard > 9) ? 14 : 0),-15);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, BalanceEvent.ZERO_BET, (event:GameEvent) => this.onZeroBet(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
    }

    private onInitGameDataParsed(data:GGParsedInitData):void {
        this._hasParsedInitData = true;
        this._isFSRestore = data.isFreespinRestore;
        this._fsLeft = data.freespinsLeft;
        this._bombSpinsLeft = data.doubleBombSpins;
        this._spinsLeft = this._isFSRestore ? this._fsLeft : this._bombSpinsLeft;
        this._isFSRestore = data.isFreespinRestore || data.isBombSpinRestore;

        if(!this._isFSRestore) {
            return;
        }
        if(data.isFreespinRestore) {
            this._badgeName = (`fsBadge_${(data.roundType === 1) ? "normal" : "super"}${data.bombGuarantee ? "_bomb" : ""}`);
        } else {
            this._badgeName = "featureSign_x2bomb";
        }
    }

    private onGameDataParsed(data:GGParsedGameData):void {
        this._fsLeft = data.freespinsLeft;
        this._bombSpinsLeft = data.doubleBombSpins;
    }

    private onRestore():void {
        if(this._isFSRestore) {
            this.showFlag(this._badgeName, this._spinsLeft, false);
        }
    }

    private onZeroBet(fsLeft?:number):void {
        if(!this._isShowing){
            return;
        }
        this.updateSpinsLeft((fsLeft == undefined || fsLeft === -1) ? this._bombSpinsLeft : fsLeft);
    }

    public showFlag(badgeName:string, spinsLeft:number, withAnimation:boolean = true):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._badgeFSType.texture = GameResources.getTextures(badgeName)[0];
        this._isShowing = true;
        this.resetPositions();
        this.updateSpinsLeft(spinsLeft, withAnimation);
        StageManager.getLayer(GGGameConfig.instance.LAYERS.REEL_FOREGROUND.name).addChild(this._badge);
        return tl;
    }

    public hideFlag(isFS:boolean = false):void {
        if(this._bombSpinsLeft > -1 && isFS) {
            this._badgeFSType.texture = GameResources.getTextures("featureSign_x2bomb")[0];
            return;
        }
        this._isShowing = false;
        if(this._effect) {
            this._effect.visible = false;
            this._effect.renderable = false;
        }
        this._numberOnBoard = 0;
        StageManager.getLayer(GGGameConfig.instance.LAYERS.REEL_FOREGROUND.name).removeChild(this._badge);
    }
}